import React from 'react';
import { PencilIcon, TrashIcon, QuestionMarkCircleIcon } from '@heroicons/react/24/outline';

const FAQCard = ({ faq, onEdit, onDelete }) => {
    return (
        <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden hover:shadow-md transition-all group">
            <div className="p-6">
                <div className="flex items-start justify-between mb-4">
                    <div className="p-3 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 text-white shadow-sm">
                        <QuestionMarkCircleIcon className="h-6 w-6" />
                    </div>
                    <div className="flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                        <button
                            onClick={() => onEdit(faq)}
                            className="p-2 hover:bg-slate-50 rounded-lg text-slate-400 hover:text-primary-600 transition-colors"
                            title="Edit"
                        >
                            <PencilIcon className="h-5 w-5" />
                        </button>
                        <button
                            onClick={() => onDelete(faq.id)}
                            className="p-2 hover:bg-slate-50 rounded-lg text-slate-400 hover:text-red-600 transition-colors"
                            title="Delete"
                        >
                            <TrashIcon className="h-5 w-5" />
                        </button>
                    </div>
                </div>

                <div className="space-y-3">
                    <h3 className="text-lg font-bold text-slate-800 leading-snug">
                        {faq.question}
                    </h3>
                    <p className="text-slate-600 text-sm leading-relaxed line-clamp-2">
                        {faq.answer}
                    </p>
                    <div className="flex items-center gap-2 pt-2">
                        <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider ${faq.is_active ? 'bg-green-50 text-green-600' : 'bg-slate-100 text-slate-500'}`}>
                            {faq.is_active ? 'Active' : 'Inactive'}
                        </span>
                        {(faq.category || faq.cat) && (
                            <span className="text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider bg-blue-50 text-blue-600">
                                {faq.category || faq.cat}
                            </span>
                        )}
                        <span className="text-dotted flex-1"></span>
                        <span className="text-[10px] font-bold text-slate-400">Order #{faq.display_order}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FAQCard;
